import React from 'react';
import cn from 'classnames';
import { string } from 'prop-types';

import { ReactComponent as StarsIcon } from '~assets/stars.svg';

import styles from './styles.module.scss';

function BenefitWarningBudget({ text, className }) {
  return (
    <div className={cn(styles.container, className)}>
      <StarsIcon className={styles.starsLogo} />
      <span className={styles.benefitText}>{text}</span>
    </div>
  );
}

BenefitWarningBudget.propTypes = {
  className: string,
  text: string
};

export default BenefitWarningBudget;
